export const timeUnits = {
  year: 'year',
  month: 'month',
  day: 'day',
  hour: 'hour',
  minute: 'minute',
  second: 'second',
} as const;

export type TimeUnit = (typeof timeUnits)[keyof typeof timeUnits];

export interface DateTimeItem {
  address: string;
  timeUnits: TimeUnit[];
}

export interface RangeTimeItem {
  address: string;
  type: 'endDate' | 'startDate';
}

type InputType = 'select' | 'radio' | 'checkbox';

export interface ConditionItem {
  value: string | number | boolean;
  type: InputType;
  address: string[];
}

export interface ConditionalItem {
  address: string;
  condition: ConditionItem[];
}

interface MappingField {
  type: InputType;
  label: string;
  values: number[];
}

export interface MappingItem {
  address: string;
  fields: MappingField[];
}

export const Widgets = {
  dateTime: 'dateTime',
  rangeTime: 'rangeTime',
  conditional: 'conditional',
  mapping: 'mapping',
  default: 'default',
} as const;

export type WidgetsTypes = (typeof Widgets)[keyof typeof Widgets];

export interface WidgetListType {
  [Widgets.dateTime]?: DateTimeItem[][];
  [Widgets.rangeTime]?: RangeTimeItem[][];
  [Widgets.conditional]?: ConditionalItem[];
  [Widgets.mapping]?: MappingItem[];
}
